import { render, staticRenderFns } from "./activityQuizResult.html?vue&type=template&id=ed949972&scoped=true&external"
import script from "./activityQuizResult.vue?vue&type=script&lang=js"
export * from "./activityQuizResult.vue?vue&type=script&lang=js"
import style0 from "./activityQuizResult.css?vue&type=style&index=0&id=ed949972&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed949972",
  null
  
)

export default component.exports